import { render, staticRenderFns } from "./LiabilitiesMortgage.vue?vue&type=template&id=94650c40"
import script from "./LiabilitiesMortgage.vue?vue&type=script&lang=js"
export * from "./LiabilitiesMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports